import {Http} from '../dimijs/src/lib/sources/http';
import {ICrudFilter, ICrudList, ICrudPagination, ICrudSorting} from '../dimijs/src/lib/sources/source';
import {IPlaylist} from './types';

export const getPlaylistsSource = (store: any, serialized?: {
    data: ICrudList<any>,
    filter: ICrudFilter<any>[],
    pagination: ICrudPagination,
    sorting?: ICrudSorting<any>[]
  }) => {
  if (serialized) {
    store.playlistsSource.source.addSerializedState(serialized.data,
      serialized.filter, serialized.pagination, serialized.sorting);
  }
  return store.playlistsSource as {
    inited: boolean,
    source: Http<IPlaylist, string>,
    playlistsSorting: ICrudSorting<IPlaylist>[],
    playlistsFilter: ICrudFilter<IPlaylist>[],
    playlistsPagination: ICrudPagination,
  };
};

export const initPlaylistsSource = (store: any, initProps: any) => {
  store.playlistsSource = {
    inited: false,
    source: null as any,
    playlistsSorting: [],
    playlistsFilter: [],
    playlistsPagination: {page: 0, countOnPage: 100},
  };
  store.playlistsSource.source = new Http<IPlaylist, string>('_id',
    // @ts-ignore
    initProps && initProps.playlists ? {
      data: {
        // @ts-ignore
        data: initProps.playlists,
      },
      filter: store.playlistsSource.playlistsFilter,
      pagination: store.playlistsSource.playlistsPagination,
      sorting: store.playlistsSource.playlistsSorting,
    } : undefined);
  store.playlistsSource.source.httpEndPoint = '/api/collections/playlists';
};
